// ABOUTME: Error surface shown when a federated module fails to load
// ABOUTME: The expected v0.1 render for an unregistered slug (empty registry)

export function ModuleErrorCard({ slug, message }: { slug: string; message?: string }) {
  return (
    <div className="m-8 rounded-lg border border-red-200 bg-red-50 p-6 text-red-900">
      <div className="font-semibold">Failed to load module: {slug}</div>
      {message ? <div className="mt-2 text-sm text-red-700">{message}</div> : null}
    </div>
  );
}
